import { Component } from '@angular/core';

@Component({
    selector: 'order-card-skeleton',
    templateUrl: 'order-card-skeleton.component.html',
    styleUrl: 'order-card-skeleton.component.scss',
    standalone: true,
})
export class OrderCardSkeletonComponent {}
